import React from 'react';
import EmployeeInformationContainer from "../Containers/EmployeeInformationContainer";
import PanelInformationItem from "../../Atoms/Items/PanelInformationItem";

const RetentionPanel = () => {
  return (
    <EmployeeInformationContainer
      title="Retención de la fuente"
      icon="folder"
    >
      <PanelInformationItem title="Método de retención" text="2" />
      <PanelInformationItem title="% de rentención" text="20" />
      <PanelInformationItem title="Deducibles vivienda" text="100,000" />
      <PanelInformationItem title="Deducibles medicina" text="100,000" />
      <PanelInformationItem title="Deducibles dependientes" text="Sí" />
    </EmployeeInformationContainer>
  );
};

export default RetentionPanel;
